import React from "react";
import { PostClient, Client } from "../types";

type ClientsContextType = {
  client: PostClient | null;
  setClient: (client: PostClient | null) => void;
  currentClient: Client | null;
  setCurrentClient: (client: Client | null) => void;
  clientUsinasIds: string[];
  setClientUsinasIds: (usinas: string[]) => void;
};

const defaultValue: ClientsContextType = {
  client: null,
  setClient: () => {},
  currentClient: null,
  setCurrentClient: () => {},
  clientUsinasIds: [],
  setClientUsinasIds: () => {},
};

export const ClientsContext = React.createContext(defaultValue);

export default function ClientsContextProvider(props: {
  children: React.ReactNode;
}) {
  const [client, setClient] = React.useState<Client | PostClient | null>(null);
  const [currentClient, setCurrentClient] = React.useState<Client | null>(null);
  const [clientUsinasIds, setClientUsinasIds] = React.useState<string[]>([]);

  return (
    <ClientsContext.Provider
      value={{
        client,
        setClient,
        currentClient,
        setCurrentClient,
        clientUsinasIds,
        setClientUsinasIds,
      }}
    >
      {props.children}
    </ClientsContext.Provider>
  );
}
